import { css } from 'styled-components'

export const lightTheme = css`
:root {
	--accentColor: #356DFF;
	--accentColorFaint: #356DFF07;
	--backgroundColor: #F4F4F4;
	--borderColor: #e0e0e0;
	--contentColor: #2f2f2f;
	--contentColorSecondary: #666666;
	--headingColor: #2d2d2d;
	--linkBackgroundColor: #e8e8e8;
}
@supports (color: color(display-p3 1 1 1)) {
	:root {
		--accentColor: color(display-p3 0.2078 0.42745 1);
		--accentColorFaint: color(display-p3 0.2078 0.42745 1 / 0.07);
	}
}
`

export const constants = {
	border: '1px solid var(--borderColor)',
	borderRadius: '0.5rem',
	fontStack: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
	headingFontStack: '"SF Compact Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
	monoFontStack: '"Iosevka", "SF Mono", Monaco, monospace',

	mobile: '600px',
	containerWidth: '700px',
	breakOutWidth: '1200px',
	largeBreakpoint: '820px',
}

export const barStyle = css`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	justify-content: space-between;
	padding: 1em 0;
	margin: 0 auto;
	a, a:visited {
		color: var(--contentColorSecondary);
	}
`

export const fullWidth = css`
	@media (min-width: ${constants.containerWidth}) {
		margin-left: max(
			calc(-${constants.breakOutWidth} / 2 + ${constants.containerWidth} / 2),
			calc(-100vw / 2 + ${constants.containerWidth} / 2)
		) !important;
		margin-right: max(
			calc(-${constants.breakOutWidth} / 2 + ${constants.containerWidth} / 2),
			calc(-100vw / 2 + ${constants.containerWidth} / 2)
		) !important;
	}
	@media (max-width: ${constants.containerWidth}) {
		margin-left: -1em !important;
		margin-right: -1em !important;
	}
`
